import { RelationEditor } from '@framework/form';
import { useTranslation } from '@framework/i18n';
import { ButtonDeleteConfirm, TableData } from '@framework/ui';
import * as React from 'react';
import { MapWidgetSelectionShape } from '../IMapWidget';
import { MapGeometryItem } from '../createMapSchema';
import { MapUnitRender } from '../layers/rendering/MapUnitRender';

export interface IMapGeometriesTableProps {
  editor: RelationEditor<MapGeometryItem>;
  readonly?: boolean;
  shape: MapWidgetSelectionShape | undefined;
  onRemove?: (id: string) => void;
}

export function MapGeometriesTable(props: IMapGeometriesTableProps) {
  const { editor, readonly, onRemove, shape } = props;
  const { t } = useTranslation();

  return (
    <div>
      <TableData
        dataSource={editor.items}
        rowKey={record => record.id}
        columns={[
          shape === MapWidgetSelectionShape.Point
            ? {
                title: 'Numero',
                key: 'number',
                render: (_, record, index) =>
                  t('map-widget.geometries.point-title', '#{{numero}}', {
                    numero: index + 1,
                  }),
              }
            : {
                title: 'Area',
                dataIndex: 'area',
                key: 'area',
                render: (value: number) => <MapUnitRender value={value} />,
              },
          {
            title: 'Azioni',
            key: 'actions',
            align: 'right',
            render: (value: MapGeometryItem) => {
              return (
                <ButtonDeleteConfirm
                  iconOnlyButton
                  buttonDanger
                  disabled={readonly}
                  tooltip="Elimina geometria"
                  okText="Elimina geometria"
                  title="Sei sicuro di voler eliminare la geometria selezionata?"
                  onConfirm={() => {
                    onRemove?.(value.id);
                  }}
                />
              );
            },
          },
        ]}
      />
    </div>
  );
}
